import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const formatDate = (date: string, format = 'YYYY/MM/DD') => {
  if (!date) return '';
  dayjs.extend(utc);
  const dateObject = dayjs(date).utc().local();
  if (!dateObject.isValid()) return '';
  return dateObject.format(format);
};
export default formatDate;
